var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteCocheRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "npbs43sflb",
    d: "M0 0L24 0 24 21 0 21z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M20.13 6.87H3.87v-.178c0-2.777 2.217-5.037 4.944-5.037h6.372c2.727 0 4.945 2.26 4.945 5.037v.178zm-1.802 6.48c-.663 0-1.201-.548-1.201-1.224 0-.675.538-1.223 1.2-1.223.664 0 1.201.548 1.201 1.223 0 .676-.537 1.223-1.2 1.223zm-12.656 0c-.663 0-1.2-.548-1.2-1.224 0-.675.537-1.223 1.2-1.223.663 0 1.2.548 1.2 1.223 0 .676-.537 1.223-1.2 1.223zm16.134-6.48h-.05v-.178c0-3.69-2.947-6.692-6.57-6.692H8.814c-3.623 0-6.57 3.002-6.57 6.692v.178h-.05C.984 6.87 0 7.873 0 9.105v6.036c0 1.232.984 2.235 2.194 2.235h.286v2.796c0 .457.364.828.812.828.449 0 .813-.37.813-.828v-2.796h15.79v2.796c0 .457.364.828.813.828.448 0 .812-.37.812-.828v-2.796h.286c1.21 0 2.194-1.003 2.194-2.235V9.105c0-1.232-.984-2.235-2.194-2.235z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteCocheRed);
export default __webpack_public_path__ + "static/media/transporteCocheRed.4adc6c5c.svg";
export { ForwardRef as ReactComponent };